// Words for a stay's money (DESIGN.md §9: sentence case, `KES 12,500`).
import { formatMoney, moneyFromCents } from '@wodi/domain';
import type { StayBilling, StayTotals } from '@wodi/shared';

import { money } from '../billing/format.ts';

/** The balance as a label and an amount: "Patient owes", "Refund due" or "Settled". */
export function balanceWords(t: Pick<StayTotals, 'balance' | 'balanceState'>): {
  label: string;
  amount: string;
} {
  const cents = BigInt(t.balance.cents);
  const amount = formatMoney(moneyFromCents(cents < 0n ? -cents : cents));
  if (t.balanceState === 'owes') return { label: 'Patient owes', amount };
  if (t.balanceState === 'refund_due') return { label: 'Refund due', amount };
  return { label: 'Settled', amount };
}

/** The stay bill's first sentence: what is owed or due, and what the deposits hold. */
export function staySentence(billing: StayBilling): string {
  const t = billing.totals;
  const parts: string[] = [];
  const { label, amount } = balanceWords(t);
  if (t.balanceState === 'settled') parts.push('Nothing is owed and nothing is due back.');
  else parts.push(`${label} ${amount}.`);
  parts.push(`Charged ${money(t.charged)} so far.`);
  if (billing.payer.kind !== 'cash')
    parts.push(`${billing.payer.name} pays ${money(t.payerAmount)}.`);
  if (t.depositsReceived.cents !== '0') parts.push(`Deposit held ${money(t.depositHeld)}.`);
  if (t.unpricedCount > 0)
    parts.push(
      t.unpricedCount === 1
        ? 'One charge has no price yet.'
        : `${String(t.unpricedCount)} charges have no price yet.`,
    );
  return parts.join(' ');
}
